import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "h5-locale-sheet__inner"
};
const _hoisted_2 = {
  class: "h5-locale-sheet__header"
};
const _hoisted_3 = {
  class: "h5-locale-sheet__title"
};
const _hoisted_4 = ["aria-label"];
const _hoisted_5 = ["aria-selected", "onClick"];
const _hoisted_6 = {
  class: "h5-locale-sheet__flag",
  "aria-hidden": "true"
};
const _hoisted_7 = {
  class: "h5-locale-sheet__text"
};
const _hoisted_8 = ["lang"];
const _hoisted_9 = {
  key: 0,
  class: "h5-locale-sheet__meta"
};
const _hoisted_10 = {
  key: 0,
  class: "h5-locale-sheet__check",
  "aria-hidden": "true"
};
import { useI18n } from 'vue-i18n';
import PmDialogShell from '@/components/shell/PmDialogShell.vue';
import { LOCALE_OPTIONS } from '@/config/localeOptions';
export default {
  __name: 'H5LocaleSheet',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'switch-locale'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const {
      locale
    } = useI18n();
    function onVisibleChange(open) {
      emit('update:modelValue', open);
    }
    function select(code) {
      if (locale.value !== code) {
        emit('switch-locale', code);
      }
      emit('update:modelValue', false);
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(PmDialogShell, {
        "model-value": __props.modelValue,
        "dialog-class": "h5-locale-sheet-dialog",
        "sheet-class": "h5-locale-sheet",
        "dialog-width": "420px",
        "show-close": false,
        "destroy-on-close": "",
        "onUpdate:modelValue": onVisibleChange
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("header", _hoisted_2, [_createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('nav.selectLanguage')), 1)]), _createElementVNode("div", {
          class: "h5-locale-sheet__list",
          role: "listbox",
          "aria-label": _ctx.$t('nav.selectLanguage')
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(LOCALE_OPTIONS), lang => {
          return _openBlock(), _createElementBlock("button", {
            key: lang.code,
            type: "button",
            class: _normalizeClass(["h5-locale-sheet__option", {
              'is-active': _unref(locale) === lang.code
            }]),
            role: "option",
            "aria-selected": _unref(locale) === lang.code,
            dir: "ltr",
            onClick: $event => select(lang.code)
          }, [_createElementVNode("span", _hoisted_6, _toDisplayString(lang.flag), 1), _createElementVNode("span", _hoisted_7, [_createElementVNode("span", {
            class: "h5-locale-sheet__label",
            lang: lang.code
          }, _toDisplayString(lang.label), 9, _hoisted_8), lang.nameZh && lang.nameZh !== lang.label ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(lang.nameZh), 1)) : _createCommentVNode("", true)]), _unref(locale) === lang.code ? (_openBlock(), _createElementBlock("span", _hoisted_10, "✓")) : _createCommentVNode("", true)], 10, _hoisted_5);
        }), 128))], 8, _hoisted_4)])]),
        _: 1
      }, 8, ["model-value"]);
    };
  }
};